webpackJsonp([67335324583948],{

/***/ 765:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/automated-food-dispenser/"},"excerpt":"When I’m relaxing, I often think about relaxing. One day, my mind wandered and I designed an automated food dispenser using a  Raspberry Pi…","timeToRead":1,"frontmatter":{"title":"An Automated Food Dispenser","tags":["css","django","javascript","python"]}}}]}},"pathContext":{"tag":"javascript"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-javascript-ccaa98cdf39cef79b9db.js